/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Itemnotfound_Searchbutton3Inputs */

const he_itemnotfound_searchbutton3 = /** @type {(inputs: Itemnotfound_Searchbutton3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חיפוש מוצרים ומבצעים`)
};

const en_itemnotfound_searchbutton3 = /** @type {(inputs: Itemnotfound_Searchbutton3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search products & deals`)
};

/**
* | output |
* | --- |
* | "Search products & deals" |
*
* @param {Itemnotfound_Searchbutton3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const itemnotfound_searchbutton3 = /** @type {((inputs?: Itemnotfound_Searchbutton3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Itemnotfound_Searchbutton3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_itemnotfound_searchbutton3(inputs)
	return en_itemnotfound_searchbutton3(inputs)
});
export { itemnotfound_searchbutton3 as "itemNotFound_searchButton" }